var EtdSource, projectDbName;

projectDbName = function() {
  return mediator.project.id;
};

EtdSource = {
  fetch: function(ids) {}
};
